import React from 'react';
import PropTypes from 'prop-types';
import { useAnalytics } from '@Shared/useAnalytics';
import { StyledMenuDrawerItem, StyledMenuButton } from './HeaderMenuMobile.styles';

const Financing = ({ shouldShowCarvanaFinancing, partner }) => {
  const { trackEventAndGo } = useAnalytics();

  const handleMainNavClick = (ev, name) => {
    trackEventAndGo(ev, 'clicked main nav link', {
      platform: 'mobile',
      link: name,
      partner: partner?.partnerVanityUrlName
    });
  };

  return (
    <>
      {shouldShowCarvanaFinancing ? (
        <StyledMenuDrawerItem>
          <StyledMenuButton
            onClick={e => handleMainNavClick(e, 'Financing')}
            dataCvTest="headerMobileFinancingLink"
            href="/financing"
            target="_self"
          >
          Financing
          </StyledMenuButton>
        </StyledMenuDrawerItem>
      ) : (
        <StyledMenuDrawerItem>
          <StyledMenuButton
            onClick={e => handleMainNavClick(e, 'Financing')}
            dataCvTest="headerMobileFinancingPartnerLink"
            href="/learn-financing"
            target="_self"
          >
          Financing
          </StyledMenuButton>
        </StyledMenuDrawerItem>
      )}
    </>
  );
};

Financing.propTypes = {
  shouldShowCarvanaFinancing: PropTypes.bool.isRequired,
  partner: PropTypes.shape({
    partnerVanityUrlName: PropTypes.string
  }).isRequired
};

export default Financing;
